var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.501,
    height: 11.503,
    viewBox: "1681.499 372.5 11.501 11.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1692.844 382.445-2.24-2.24a.539.539 0 0 0-.382-.157h-.366a4.672 4.672 0 1 0-8.357-2.876 4.672 4.672 0 0 0 7.548 3.685v.366c0 .144.056.281.157.382l2.24 2.24a.537.537 0 0 0 .762 0l.635-.636a.542.542 0 0 0 .003-.764Zm-6.673-2.397a2.874 2.874 0 0 1-2.875-2.875 2.874 2.874 0 0 1 2.875-2.876 2.874 2.874 0 0 1 2.876 2.876 2.874 2.874 0 0 1-2.876 2.875Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Icon awesome-search"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.1b49c92552455171bdceacda5cae9630.svg";
export { ForwardRef as ReactComponent };